<template lang="pug">
div
  .gameplay-wrapper.vv-gp
    .gpnav
      .items.vv-gpnav-show
        div(@click="triggerMenu(1)")
          svg(id='fi_3018442' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg')
            circle(cx='12' cy='12' r='2')
            circle(cx='4' cy='12' r='2')
            circle(cx='20' cy='12' r='2')
        div(@click="redirectPath()")
          svg(enable-background='new 0 0 512 512' height='24' viewBox='0 0 512 512' width='24' xmlns='http://www.w3.org/2000/svg' id='fi_5254940')
            path(d='m292.2 256 109.9-109.9c10-10 10-26.2 0-36.2s-26.2-10-36.2 0l-109.9 109.9-109.9-109.9c-10-10-26.2-10-36.2 0s-10 26.2 0 36.2l109.9 109.9-109.9 109.9c-10 10-10 26.2 0 36.2 5 5 11.55 7.5 18.1 7.5s13.1-2.5 18.1-7.5l109.9-109.9 109.9 109.9c5 5 11.55 7.5 18.1 7.5s13.1-2.5 18.1-7.5c10-10 10-26.2 0-36.2z')
    .gpholder
      iframe.vv-gp-iframe(:src="gameUrl")
  .gameplay-popover-wrapper.vv-gppop(v-if="showMenu")
    .gppop
      .overlay
      .ccon
        .items
          router-link(to="deposit") Deposit
          //- a(href='#') Add Favorite
          //- a(href='#') Reload
          a(href='javascript:void(0)' @click="triggerMenu(2)") Cancel
  //- .lobby
    .float-button.pointer(@click="redirectPath()") BACK
    .container
      iframe.responsive-iframe(:src='gameUrl')
  
  </template>
  <script>
  import config from '@/config'
  import _ from "lodash";
  export default{
    data(){
      return{
        // gameId: "",
        // gameName: "",
        gameUrl: "",
        showMenu: false,
        gameLaunching: true,
        userPlatform:null
      }
    },
    computed:{
    },
    created(){
      this.getMobile()
    },
    mounted(){
      window.scroll(0,0)
      if(!_.isEmpty(this.$route.params)){
        this.gameUrl = this.$route.params.id
      }
    },
    methods:{
      triggerMenu(option){
        if(option === 1){
          this.showMenu = true
        }else{
          this.showMenu = false
        }
        
      },
      redirectPath(){
        this.$router.push("/freeplay").catch(error =>{})
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .lobby{
    padding: 0;
    margin: 0;
    border: 0;
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 0;
    margin: 0;
    border: 0;
  }
  .responsive-iframe {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 0;
    padding: 0;
    margin: 0;
    border: 0;
  }
  .float-button {
    font-family: Tahoma;
    font-weight: bold;
    padding: 16px;
    position: absolute;
    left: 0;
    top: 0;
    margin: 4px;
    z-index: 1000;
    background: #ffffffcc;
    border-radius: 5px;
    
  }
  </style>